export const PRICING_TABS = {
  QUICK_LOOKUP: 'quickLookup',
  BY_CLIENT: 'byClient',
  BY_LOT: 'byLot',
  BY_ACTIVITY: 'byActivity',
  BULK_OPERATIONS: 'bulkOperations'
};

export const PRICING_TAB_LABELS = {
  [PRICING_TABS.QUICK_LOOKUP]: 'Quick Lookup',
  [PRICING_TABS.BY_CLIENT]: 'By Client',
  [PRICING_TABS.BY_LOT]: 'By Lot',
  [PRICING_TABS.BY_ACTIVITY]: 'By Activity',
  [PRICING_TABS.BULK_OPERATIONS]: 'Bulk Operations'
};

export const ActivityItemPriceModes = {
  COST_PLUS: 1,
  CLIENT_DICTATED: 2
}

export const ActivityItemPricingType = {
  SIMPLE: 1,
  BASE_PLUS_MATERIALS: 2
}

export const DIFFERENT_PREFERRED_VENDOR_TOOLTIP = (vendorName) => `Different preferred vendor: ${vendorName}`;
